import React, { useEffect } from 'react';
import MediaQuery from 'react-responsive';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import classnames from 'classnames';
import values from 'lodash/values';
import StringFormatter from '../../common/StringFormatter';
import DtmTags from '../../common/dtmTags';
import mixpanelConstants from '../../common/mixpanelConstants';
import Classes from '../../common/Classes';
import Tags from '../Tags';
import Brands from './components/Brands';
import Label from '../../common/components/Label';
import Name from './components/Name';
import Stand from './components/Stand';
import FavouriteComponent from './components/FavouriteComponent';
import ExhibitorInfo from './components/ExhibitorInfo';
import ContactOptions from '../ContactOptions';
import {DataDtmActions, ExhibitorFeatures, Packages, SessionStorageKeys,} from '../../common/Constants';
import MainStandHolderName from './components/MainStandHolderName';
import FollowComponent from './components/FollowComponent';
import Utils from '../../common/Utils';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../../../styles/products-document-container.less'
import {trackImpressions, trackMixpanelEvent} from '../../common/MixpanelHelper';
import ExhibitorInfoSection from './components/premiumSection/ExhibitorInfoSection';
import ExhibitorLogo from './components/ExhibitorLogo';

const ExhibitorPremiumPackage = (props) => {
  const targetRef = React.createRef();
  let exhibitorObserver = null;

  const shouldBeSponsoredCategory = () => (props.exhibitor.sponsoredCategory != null
      && props.exhibitor.sponsoredCategory.id !== undefined
      && props.exhibitor.sponsoredCategory.id !== '');

  const isSponsoredCategory = shouldBeSponsoredCategory();

  useEffect(() => {
    const exhibitor = props.exhibitor;
    let mixPanelProperties = {
      exhibitorId: exhibitor.id,
      exhibitorName: exhibitor.name,
      packageName: Utils.getPackageName(exhibitor.packageId),
      component: mixpanelConstants.component.exhibitorDirectory,
      subComponent: props.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
    }
    exhibitorObserver = trackImpressions(mixpanelConstants.eventName.exhibitorImpression, mixPanelProperties, 0);
    if (targetRef.current) {
      exhibitorObserver.observe(targetRef.current);
    }

    return () => {
      if (exhibitorObserver) {
        exhibitorObserver.disconnect();
      }
    }
  }, []);

  const getDtmTagsForPackage = (packageId) => {
    const wrapSponsoredCategoryTag = tag => `${tag}${(isSponsoredCategory) ? '_sponsored' : ''}`;
    let tags = {};
    const results = {};
    const ignoreTags = ['exhibitor', 'prioritySlot'];
    if (packageId === Packages.gold) {
      tags = DtmTags.exhibitorDirectory.gold;
    } else {
      tags = DtmTags.exhibitorDirectory.silver;
    }

    Object.keys(tags).forEach((key) => {
      results[key] = !ignoreTags.includes(key) ? wrapSponsoredCategoryTag(tags[key]) : tags[key];
    });

    return results;
  };

  const sponsoredCategoryHasName = () => (props.exhibitor.sponsoredCategory != null
      && props.exhibitor.sponsoredCategory.name !== undefined
      && props.exhibitor.sponsoredCategory.name !== '')


  const triggerMixpanelEvent = (element) => {
    const exhibitor = props.exhibitor;
    let mixpanelProps = {exhibitorId: exhibitor.id, exhibitorName: exhibitor.name, packageName: Utils.getPackageName(exhibitor.packageId),
      element: element, component: mixpanelConstants.component.exhibitorDirectory,
      subComponent: props.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard}
    if(element === mixpanelConstants.element.mainStandHolderTitle) {
    mixpanelProps = {...mixpanelProps, exhibitorId: exhibitor.parentId, exhibitorName: exhibitor.mainStandHolderName, packageName: Utils.getPackageName(exhibitor.mainStandHolderPackageId)}
    }
      trackMixpanelEvent(mixpanelConstants.eventName.exhibitorClicked, mixpanelProps)
  }

  const getFeaturesInOrder = (exhibitor,translations) => {
    let features = [];
    let exhibitorFeatures = exhibitor.features ? exhibitor.features: []
    if(sponsoredCategoryHasName()) {
      features.push(
          <Label
            featureNameKey={exhibitor.sponsoredCategory.name}
            translations={translations.features}
            tags={DtmTags.exhibitorDirectory}
            exhibitorId={exhibitor.id}
            prefix={translations.sponsorCategoryLabel}
          />
      )
    }
    if(exhibitorFeatures.includes(ExhibitorFeatures.New)){
      features.push(
          <Label
            featureNameKey={ExhibitorFeatures.New}
            translations={translations.features}
            tags={DtmTags.exhibitorDirectory}
            exhibitorId={exhibitor.id}
          />
      )
    }
    return features;
  }

  const {
    exhibitor, translations, detailPageLinkFormat, defaultLogoUrl, isInShowPlan, showPlanningEnabled, showFollowButton, interfaceLocale,
    isFollowing, handleFollowClick, userId, eventEditionId,
    hideStandInfo, isMercuryParticipantShow
  } = props;

  let detailPageLink;
  const environment = Utils.getCurrentEnvironment();
  if(!Utils.isDevEnvironment(environment)  && !Utils.isShowEnvironment(environment) && exhibitor.name) {
    //replaces spaces with '-' from company name with meaning full name
    let exhibitorName = Utils.getSEOFriendlyName(exhibitor.name);
    detailPageLink = StringFormatter.format(detailPageLinkFormat, exhibitorName.concat('.', exhibitor.organisationGuid));
  }
  else{
    detailPageLink = StringFormatter.format(detailPageLinkFormat, exhibitor.organisationGuid);
  }

  const dtmTags = getDtmTagsForPackage(exhibitor.packageId);
  const excludeTagCharacter = '>';
  const features = getFeaturesInOrder(exhibitor,translations);

  const isPrimaryEventEdition =  Utils.getFromSessionStorage(SessionStorageKeys.isPrimaryEventEdition);

  const initialState = (isPrimaryEventEdition || isMercuryParticipantShow) ? isFollowing : isInShowPlan;
  const translationsForFavouritecomponent = (isPrimaryEventEdition || isMercuryParticipantShow) ? translations.follow : translations.favourite;

  const directoryItemStyles = {
    backgroundColor: `${window.reactSettings.props.themes.brandPrimary}08`,
    '--brand-color': window.reactSettings.props.themes.brandPrimary
  }
  function isPpsAnswersExists() {
    return exhibitor.ppsAnswers && exhibitor.ppsAnswers.length > 0;
  }

  function shouldShowFavouriteComponent() {
    return isMercuryParticipantShow || (!isPrimaryEventEdition || showFollowButton)
  }

  function isContactsAvailable() {
    return exhibitor.website || exhibitor.email || exhibitor.phone;
  }

  function getTagComponent(showHeading = true){
    return (
        <>
          { isPpsAnswersExists() ? (
              <Tags
                  showHeading={showHeading}
                  sponserCategory={sponsoredCategoryHasName() && props.exhibitor.sponsoredCategory.name}
                  tags={exhibitor.ppsAnswers.map(answer => (answer.includes(': ') ? answer.split(': ')[1] : answer))}
                  detailPageLink={detailPageLink}
                  triggerMixpanelEvent={triggerMixpanelEvent}
                  categoriesLabel={translations.categoriesLabel}
              />
          ) : (
              <Tags
                  showHeading={showHeading}
                  sponserCategory={sponsoredCategoryHasName() && props.exhibitor.sponsoredCategory.name}
                  tags={values(exhibitor.filters)
                      .reduce((acc, cur) => acc.concat(...values(cur)), [])
                      .filter(val => !val.includes(excludeTagCharacter))
                      .map(tag => (tag.includes(': ') ? tag.split(': ').slice(1).join(': ') : tag))}
                  detailPageLink={detailPageLink}
                  triggerMixpanelEvent={triggerMixpanelEvent}
                  categoriesLabel={translations.categoriesLabel}
              />
          )}
      </>
    )
  }

  function getFeatures() {
    return <>
      {
          features.length > 0 &&
          <div className={Classes.exhibitorFeaturesContainer}>
            {features}
          </div>
      }
    </>;
  }

  function getFollowAndFavourite() {
    return <>
      {
        shouldShowFavouriteComponent() ?
            <FavouriteComponent
                exhibitor={exhibitor}
                translations={translationsForFavouritecomponent}
                showPlanningEnabled={showPlanningEnabled}
                initialState={initialState}
                className={[Classes.favouiteTabletOnly]}
                dtmData={DtmTags.exhibitorDirectory}
                isPrimaryEventEdition={isPrimaryEventEdition}
                isMercuryParticipantShow={isMercuryParticipantShow}
                handleFollowClick={handleFollowClick}
                locale={interfaceLocale}
                type="exhibitor"
                component={mixpanelConstants.component.exhibitorDirectory}
                isPrioritySlotPremiumExhibitor={props.isPrioritySlotPremiumExhibitor}
            /> : null
      }
      {!isMercuryParticipantShow && (showFollowButton && !isPrimaryEventEdition) ?
          <FollowComponent
            isFollowed={isFollowing}
            translations={translations.follow}
            locale={interfaceLocale}
            baseApiUrl={props.baseApiUrl}
            digitalPortfolioId={props.digitalPortfolioId}
            organisationId={exhibitor.organisationGuid}
            handleFollowClick={handleFollowClick}
            dtmData={DtmTags.exhibitorDirectory}
            userId={userId}
            exhibitingOrganisationId={exhibitor.id}
          /> : null
      }
    </>;
  }
  function getExhibitorSummary() {
    return <div className={Classes.exhibitorSummary}>
      <Name
        exhibitor={exhibitor}
        detailPageLink={detailPageLink}
        tags={dtmTags}
        triggerMixpanelEvent={triggerMixpanelEvent}
      />
      {getFeatures()}
      <div className={Classes.description}>
        <ExhibitorInfo
            showHeading={false}
            label={translations.descriptionTitle}
            content={exhibitor.description}
            detailPageLink={detailPageLink}
            id={exhibitor.id}
            testId="show-description"
            tag={props.isPrioritySlotPremiumExhibitor ? dtmTags.description + dtmTags.prioritySlot : dtmTags.description}
            triggerMixpanelEvent={triggerMixpanelEvent}
            element={mixpanelConstants.element.description}
        />
        <Brands
            representedBrands={exhibitor.representedBrands}
            translations={translations}
            detailPageLink={detailPageLink}
            id={exhibitor.id}
            tag={props.isPrioritySlotPremiumExhibitor ? dtmTags.representedBrands + dtmTags.prioritySlot : dtmTags.representedBrands}
            triggerMixpanelEvent={triggerMixpanelEvent}
        />
        {getTagComponent(true)}
        <MediaQuery minWidth={768} maxWidth={1198}>
          {
              isContactsAvailable() &&
                <ContactOptions
                  exhibitor={exhibitor}
                  translations={translations}
                  tags={dtmTags}
                />
          }
        </MediaQuery>
      </div>
    </div>;
  }

  function getStands() {
    return <>
      {exhibitor.standReference &&
          exhibitor.standReference.trim().length > 0 && !hideStandInfo &&
          <Stand
            standReference={exhibitor.standReference}
            translations={translations}
            dtmTags={DtmTags.exhibitorDirectory.stands}
            exhibitorId={JSON.stringify(exhibitor.id)}
            mixpanelProps={{
              exhibitorId: exhibitor.id,
              exhibitorName: exhibitor.companyName,
              packageName: Utils.getPackageName(exhibitor.packageId),
              component: mixpanelConstants.component.exhibitorDirectory,
              element: mixpanelConstants.element.moreStands,
              subComponent: mixpanelConstants.subComponent.standard
            }}
          />
      }
    </>
  }

  function getMSHandExhibitorInfoSection() {
    return <>
      <ExhibitorInfoSection
          exhibitor={exhibitor}
          translations={translations}
          isPrioritySlotPremiumExhibitor={props.isPrioritySlotPremiumExhibitor}
          navigation={props.navigation}
      />
      {exhibitor.mainStandHolderName &&
          <MainStandHolderName
              exhibitor={exhibitor}
              translations={translations}
              detailPageLinkFormat={detailPageLinkFormat}
              tags={DtmTags.exhibitorDirectory}
              triggerMixpanelEvent={triggerMixpanelEvent}
          />}
    </>;
  }

  function getContactContainer() {
    return <div className={Classes.exhibitorContactContainer}>
      {getStands()}
      {getFollowAndFavourite()}
      <MediaQuery minWidth={1199}>
        {
          isContactsAvailable() &&
            <ContactOptions
              exhibitor={exhibitor}
              translations={translations}
              tags={dtmTags}
            />
        }
      </MediaQuery>
    </div>;
  }

  return (
      <Row
          className={classnames(Classes.directoryItem, Classes.directoryItemPremiumFeatureToggle, Classes.primaryBorderColor)}
          style={directoryItemStyles}
          data-dtm={props.isPrioritySlotPremiumExhibitor ? dtmTags.exhibitor + dtmTags.prioritySlot : dtmTags.exhibitor}
          data-dtm-attributes={JSON.stringify({ exhibitorId: exhibitor.id })}
      >
        <div ref={targetRef}>
          <div
              className={classnames(Classes.directoryItemPremiumBannerText, Classes.primaryButtonTextColor)}
              style={{backgroundColor: window.reactSettings.props.themes.brandPrimary}}
          >
            {translations.goldPackageBannerText}
          </div>

          <MediaQuery minWidth={1199}>
            <div className={classnames(Classes.directoryItemFeatureToggled, Classes.exhibitorCategory)}
                 data-testid='row-desktop'
                 data-dtm={props.isPrioritySlotPremiumExhibitor ? dtmTags.exhibitor + dtmTags.prioritySlot : dtmTags.exhibitor}
                 data-dtm-attributes={JSON.stringify({ exhibitorId: exhibitor.id })}
                 data-dtm-actions={DataDtmActions.view}
            >
              <div className={Classes.exhibitorDetailContainer}>
                <ExhibitorLogo
                    exhibitor={exhibitor}
                    detailPageLink={detailPageLink}
                    defaultLogoUrl={defaultLogoUrl}
                    tags={dtmTags}
                    triggerMixpanelEvent={triggerMixpanelEvent}
                />
                {getExhibitorSummary()}
                {getContactContainer()}
              </div>
              {getMSHandExhibitorInfoSection()}
            </div>
          </MediaQuery>
          <MediaQuery minWidth={768} maxWidth={1198}>
            <div className={classnames(Classes.directoryItemFeatureToggled, Classes.exhibitorCategory)}
                 data-testid='row-desktop'
                 data-dtm={props.isPrioritySlotPremiumExhibitor ? dtmTags.exhibitor + dtmTags.prioritySlot : dtmTags.exhibitor}
                 data-dtm-attributes={JSON.stringify({ exhibitorId: exhibitor.id })}
                 data-dtm-actions={DataDtmActions.view}
            >
              <div className={Classes.exhibitorDetailContainer}>
                <div className={Classes.logoStandContainer}>
                  <ExhibitorLogo
                      exhibitor={exhibitor}
                      detailPageLink={detailPageLink}
                      defaultLogoUrl={defaultLogoUrl}
                      tags={dtmTags}
                      triggerMixpanelEvent={triggerMixpanelEvent}
                  />
                  {getContactContainer()}
                </div>
                {getExhibitorSummary()}
              </div>
              {getMSHandExhibitorInfoSection()}
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <div className={classnames(Classes.directoryItemFeatureToggled, Classes.exhibitorCategory)}
                 data-dtm={props.isPrioritySlotPremiumExhibitor ? dtmTags.exhibitor + dtmTags.prioritySlot : dtmTags.exhibitor}
                 data-dtm-attributes={JSON.stringify({ exhibitorId: exhibitor.id })}
                 data-dtm-actions={DataDtmActions.view}
            >
              <div className={Classes.exhibitorDetailContainer}>
                <ExhibitorLogo
                    exhibitor={exhibitor}
                    detailPageLink={detailPageLink}
                    defaultLogoUrl={defaultLogoUrl}
                    tags={dtmTags}
                    triggerMixpanelEvent={triggerMixpanelEvent}
                />
                <div className={Classes.exhibitorSummary}>
                  <Name
                    exhibitor={exhibitor}
                    detailPageLink={detailPageLink}
                    tags={dtmTags}
                    triggerMixpanelEvent={triggerMixpanelEvent}
                  />
                  {getStands()}
                  <div className={Classes.showPlanBtns}>
                    {getFollowAndFavourite()}
                  </div>

                </div>
              </div>
              {getFeatures()}
              <div className={classnames(Classes.premiumPackageFeatureToggled)}>
                <Row>
                  <Col className={classnames(Classes.descriptionContainer, Classes.descriptionContainerMargin)}>
                    <div className={Classes.description}>
                      <ExhibitorInfo
                          showHeading={false}
                          content={exhibitor.description}
                          detailPageLink={detailPageLink}
                          id={exhibitor.id}
                          testId={'show-description'}
                          tag={props.isPrioritySlotPremiumExhibitor ? dtmTags.description + dtmTags.prioritySlot : dtmTags.description}
                          triggerMixpanelEvent={triggerMixpanelEvent}
                          element={mixpanelConstants.element.description}
                      />
                    </div>
                    <div className={Classes.tags}>
                      {getTagComponent(false)}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </MediaQuery>
        </div>
      </Row>
  );
}

export default ExhibitorPremiumPackage;
